// extracted by mini-css-extract-plugin
export var button = "tag-module--button--16e92";
export var icon = "tag-module--icon--424a7";
export var label = "tag-module--label--6dab3";
export var wrapper = "tag-module--wrapper--38d91";